const urls = {
  // 3.0报表URL
  reportUrl: 'http://report.choicelink.cn:8095',
  // 报表数据页面链接
  webReportUrl: 'http://report.choicelink.cn:8084',
  // siteserver API Url
  siteserverUrl: 'http://www.chinapsp.cn',
  // 网关URL
  apiUrl: 'https://newapi.chinapsp.cn',
  // 报名请求
  enroll: {
    // 分页获取
    getPaged: '/api/services/app/AbpEnroll/GetPaged',
    // 指定ID获取订单
    getById: '/api/services/app/AbpEnroll/GetById',
    // 添加或修改
    createOrUpdate: '/api/services/app/AbpEnroll/CreateOrUpdate',
    // 报名拓展获取
    GetEnrollExt: '/api/services/app/AbpEnroll/GetEnrollExt',
    // 中标确认(新)
    SetWinBid: '/api/services/app/AbpEnroll/SetWinBid',
    // 取消中标
    SetUndoWindBid: '/api/services/app/AbpEnroll/SetUndoWindBid',
    // 资格标确认
    SetWinQualification: '/api/services/app/AbpEnroll/SetWinQualification',
    // 报名附属表分页获取
    GetPagedExt: '/api/services/app/AbpEnroll/GetPagedExt',
    // 报名非权限限制
    GetPagedWithoutRole: '/api/services/app/AbpEnroll/GetPagedWithoutRole',
    // 中标确认（百分比计算）
    SetWinPercent: '/api/services/app/AbpEnroll/SetWinPercent'
  },
  // 订单请求
  order: {
    // 分页获取
    getPaged: '/api/services/app/AbpOrders/GetPaged',
    // 创建订单(各类订单)
    CreateOrders: '/api/services/app/AbpOrders/CreateOrders',
    // 红票订单
    createRedOrders: '/api/services/app/AbpOrders/CreateRedOrders',
    // 修改状态
    updateOrder: '/api/services/app/AbpOrders/UpdateOrders',
    // 订单支付修改
    updateOrdersPay: '/api/services/app/AbpOrders/UpdateOrdersPay',
    // 手工开红票
    ManualRedOrders: '/api/services/app/AbpOrders/ManualRedOrders',
    // 直接插入应标
    ProjectCreateOrders: '/api/services/app/AbpOrders/ProjectCreateOrders',
    // 保证金领取
    MarginOrdersList: '/api/services/app/AbpOrders/MarginOrdersList',
    // 订单确认
    OrdersConfirm: '/api/services/app/AbpOrders/OrdersConfirm',
    // 订单删除
    Delete: '/api/services/app/AbpOrders/Delete',
    // 订单确认
    GetMarginConfirm: '/api/services/app/AbpOrders/GetMarginConfirm',
    // 创建退保订单
    CreateRefund: '/api/services/app/AbpOrders/CreateRefund',
    // 创建退保订单（批量）
    CreateRefundList: '/api/services/app/AbpOrders/CreateRefundList',
    // 订单带包组分页
    GetPagedGroup: '/api/services/app/AbpOrders/GetPagedGroup',
    // 检查是否已经领取
    MarginExistsList: '/api/services/app/AbpOrders/MarginExistsList',
    // 广发保证金集合
    MarginDateilOrdersList: '/api/services/app/AbpOrders/MarginDateilOrdersList',
    // 广发退保证金订单创建
    GfCreateRefund: '/api/services/app/AbpOrders/GfCreateRefund',
    // 订单流程状态修改
    SetOrdersFlowStatus: '/api/services/app/AbpOrders/SetOrdersFlowStatus',
    // 根据订单号修改状态
    UpdateOrdersByNumber: '/api/services/app/AbpOrders/UpdateOrdersByNumber',
    // 批量修改订单状态
    BatchUpdateOrders: '/api/services/app/AbpOrders/BatchUpdateOrders'
  },
  // 公司信息
  company: {
    // 分页获取
    getPaged: '/api/services/app/AbpCompany/GetPaged',
    // 添加或修改
    createOrUpdate: '/api/services/app/AbpCompany/CreateOrUpdate',
  },
  // 发票
  orderInvoice: {
    getPaged: '/api/services/app/AbpOrderInvoice/GetPaged',
    // 开票
    openInvoice: '/api/services/app/AbpOrderInvoice/OpenInvoice',
    // 诺诺开票（深圳使用）
    NnOpenInvoice: '/api/services/app/AbpOrderInvoice/NnOpenInvoice',
    // 诺诺发票（更新状态）
    NnQueryInvoice: '/api/services/app/AbpOrderInvoice/NnQueryInvoice',
    // 诺诺红冲发票
    NnCreateRedInvoice: '/api/services/app/AbpOrderInvoice/NnCreateRedInvoice',
    // 手工开票
    ManualInvoice: '/api/services/app/AbpOrderInvoice/ManualInvoice',
    // 服务费手工开票
    ServiceInvoice: '/api/services/app/AbpOrderInvoice/ServiceInvoice',
    // 补录发票
    InvoiceRepair: '/api/services/app/AbpOrderInvoice/InvoiceRepair',
    // 修改发票信息
    ModifyInvoiceNumber: '/api/services/app/AbpOrderInvoice/ModifyInvoiceNumber',
    // 创建红冲发票
    CreateRedInvoice: '/api/services/app/AbpOrderInvoice/CreateRedInvoice',
    // 创建手工发票
    ManualRedInvoice: '/api/services/app/AbpOrderInvoice/ManualRedInvoice',
    // 订单关联转移
    InvoiceMigrate: '/api/services/app/AbpOrderInvoice/InvoiceMigrate'
  },
  // 公告
  articles: {
    // 分页获取
    getPaged: '/api/services/app/AbpArticles/GetPaged',
    // 添加或修改
    CreateOrUpdate: '/api/services/app/AbpArticles/CreateOrUpdate',
    // 删除公告
    Delete: '/api/services/app/AbpArticles/Delete',
    // 公告审核
    ArticlesStatusUpdate: '/api/services/app/AbpArticles/ArticlesStatusUpdate'
  },
  articlesData: {
    // 分页获取
    getPaged: '/api/services/app/AbpArticleData/GetPaged',
    // 添加或修改
    CreateOrUpdate: '/api/services/app/AbpArticleData/CreateOrUpdate',
    // 通过articleId查公告
    GetArticleDataByAIdAsync: '/api/services/app/AbpArticleData/GetArticleDataByAIdAsync'
  },
  // 上传文件
  dbFile: {
    getPaged: '/api/services/app/AbpDbFile/GetPaged',
  },
  // 内部文件服务器
  clfile: {
    getPaged: '/api/services/app/ClDbFile/GetPaged',
    getList: '/api/services/app/ClDbFile/GetList',
    delFile: '/api/services/app/ClDbFile/Delete',
    CreateOrUpdate: '/api/services/app/ClDbFile/CreateOrUpdate'
  },
  // 获取银行信息
  bankAccount: {
    // 获取所有银行账户信息
    getAll: '/api/services/app/AbpBankAccount/GetAll'
  },
  // 项目信息
  ClProjectDb: {
    // 分页获取
    getPaged: '/api/services/app/ClProjectDb/GetPaged',
    // 招标挂网
    UpdateNet: '/api/services/app/ClProjectDb/UpdateNet',
    // 更正挂网
    UpdateCorrect: '/api/services/app/ClProjectDb/UpdateCorrect',
    // 结果挂网
    UpdateWin: '/api/services/app/ClProjectDb/UpdateWin',
    // 更新项目状态
    UpdateStatus: '/api/services/app/ClProjectDb/UpdateStatus',
    // 结项状态
    UpdateEndStatus: '/api/services/app/ClProjectDb/UpdateEndStatus',
    // 修改项目信息
    CreateOrUpdate: '/api/services/app/ClProjectDb/CreateOrUpdate',
    // 生成项目编号
    GetProjectNumber: '/api/services/app/ClProjectDb/GetProjectNumber',
    // 项目文件编制时间
    ProjectTime: '/api/services/app/ClProjectDb/ProjectTime',
    // 计算项目应收
    SetProjectReceivable: '/api/services/app/ClProjectDb/SetProjectReceivable'
  },
  // 包组信息
  ClGroupDb: {
    // 分页获取
    getPaged: '/api/services/app/ClGroupDb/GetPaged',
    // 新建包组
    CreateOrUpdate: '/api/services/app/ClGroupDb/CreateOrUpdate',
    // 删除包组
    Delete: '/api/services/app/ClGroupDb/Delete',
    // 包组失败
    SetGroupFail: '/api/services/app/ClGroupDb/SetGroupFail',
    // 获取包组下财务信息
    GetProjectCharge: '/api/services/app/ClGroupDb/GetProjectCharge'
  },
  // 会议室&电子评标
  AbpRoom: {
    // 分页获取
    getPaged: '/api/services/app/AbpRoom/GetPaged',
  },
  // 获取包组报名供应商
  YbDb: {
    getPaged: '/api/services/app/YbDb/GetPaged',
    // 设置中标
    SetWinBid: '/api/services/app/YbDb/SetWinBid',
    // 取消中标
    SetUndoWindBid: '/api/services/app/YbDb/SetUndoWindBid',
    // 下浮率中标
    SetWinLower: '/api/services/app/YbDb/SetWinLower',
    // 修改应标
    CreateOrUpdate: '/api/services/app/YbDb/CreateOrUpdate'
  },
  // 获取文件汇总文件类型
  ClFileGather: {
    // 获取项目的所有文件及类型
    GetFileGather: '/api/services/app/ClFileGather/GetFileGather'
  },
  // 专家品目
  AbpItems: {
    GetList: '/api/services/app/AbpItems/GetList'
  },
  // 服务费
  AbpServiceCharge: {
    getPaged: '/api/services/app/AbpServiceCharge/GetPaged',
    getById: '/api/services/app/AbpServiceCharge/GetById',
    createOrUpdate: '/api/services/app/AbpServiceCharge/CreateOrUpdate',
    ServiceChargeConfirm: '/api/services/app/AbpServiceCharge/ServiceChargeConfirm',
    ServiceRepair: '/api/services/app/AbpServiceCharge/ServiceRepair'
  },
  // 保证金
  ClMargin: {
    getPaged: '/api/services/app/ClMargin/GetPaged',
    CreateOrUpdate: '/api/services/app/ClMargin/CreateOrUpdate',
    ExcelImport: '/api/services/app/ClMargin/ExcelImport',
    // 创建保证金账号
    CreateAccount: '/api/services/app/ClMargin/CreateAccount',
    // 获取保证金账号
    GetByProjectId: '/api/services/app/ClMargin/GetByProjectId',
    // 获取领取信息1（广发保证金账号自动匹配）
    GetMarginDetailsPagedByProject: '/api/services/app/ClMargin/GetMarginDetailsPagedByProject',
    // 获取领取信息3
    GetMarginPaged: '/api/services/app/ClMargin/GetMarginPaged',
    // 刷新明细（废弃）
    RefreshMarginDetail: '/api/services/app/ClMargin/RefreshMarginDetail',
    // 检查到帐保证金供应商名称差异
    GetDifferent: '/api/services/app/ClMargin/GetDifferent',
    // 广发保证金退款
    MarginRefund: '/api/services/app/ClMargin/MarginRefund',
    // 批量广发保证金退款
    MarginRefundList: '/api/services/app/ClMargin/MarginRefundList',
    // 广发保证金状态查询
    RefundStatus: '/api/services/app/ClMargin/RefundStatus',
    // 刷新保证金明细表
    // RefreshMargin: '/api/services/app/ClMargin/RefreshMargin',
    RefreshMargin: '/api/services/app/ClMargin/RefreshMarginList',
    // 更改保证金状态
    UpdateMarginStatus: '/api/services/app/ClMargin/UpdateMarginStatus'
  },
  AbpRefundMargin: {
    // 获取退保分页
    GetPaged: '/api/services/app/AbpRefundMargin/GetPaged',
    // 获取退保
    GetById: '/api/services/app/AbpRefundMargin/GetById',
    // 修改退保信息
    CreateOrUpdate: '/api/services/app/AbpRefundMargin/CreateOrUpdate',
    // 广发退保单创建
    GfCreateOrUpdate: '/api/services/app/AbpRefundMargin/GfCreateOrUpdate',
    // 批量创建广发保证金订单
    GfCreateOrUpdateList: '/api/services/app/AbpRefundMargin/GfCreateOrUpdateList',
  },
  AbpDataDict: {
    //数据集
    getpage: '/api/services/app/AbpDataDict/GetPaged',
    // 数据集非分页获取
    GetList: '/api/services/app/AbpDataDict/GetList',
    // 数据集不带租户
    GetListByTypeWithNoTenant: '/api/services/app/AbpDataDict/GetListByTypeWithNoTenant'
  },
  Export: {
    ExportOrderResult: '/api/Export/ExportOrderResult'
  },
  // 会议室
  ClMeetingRoom: {
    // 获取预约会议室
    GetRoomList: '/api/services/app/ClMeetingRoom/GetRoomList'
  },
  // 用户修改
  User: {
    // 批量修改地区
    BatchUpdateDistrict: '/api/services/app/User/BatchUpdateDistrict',
    // 根据角色ID查询用户列表
    GetUserListByRole: '/api/services/app/User/GetUserListByRole',
  },
  CLDistrict: {
    // 获取地区（不带权限）
    GetPaged: '/api/services/app/CLDistrict/GetPaged',
    // 获取地区（带权限）
    GetList: '/api/services/app/CLDistrict/GetList',
    GetListWithoutRole: '/api/services/app/CLDistrict/GetListWithoutRole'
  },
  CompanyBonus: {
    // 初始化规则数据
    Init: '/api/services/app/CompanyBonus/Init',
    // 获取规则数据
    GetList: '/api/services/app/CompanyBonus/GetList',
    // 规则奖金批量更新
    BonusUpdateList: '/api/services/app/CompanyBonus/BonusUpdateList',
    // 月度任务查询
    GetListTask: '/api/services/app/CompanyBonus/GetListTask',
    // 月度任务集合添加
    MonthlyTaskList: '/api/services/app/CompanyBonus/MonthlyTaskList'
  },
  // 投标管理2
  ClBidManage: {
    GetPaged: '/api/services/app/ClBidManage/GetPaged',
    GetById: '/api/services/app/ClBidManage/GetById',
    CreateOrUpdate: '/api/services/app/ClBidManage/CreateOrUpdate',
    Delete: '/api/services/app/ClBidManage/Delete',
  },
  AbpAliOss: {
    GetListByObjectId: '/api/services/app/AbpAliOss/GetListByObjectId',
    GetDownUrl: '/api/services/app/AbpAliOss/GetDownUrl',
    Delete: '/api/services/app/AbpAliOss/Delete',
  },
  AbpFlowLog: {
    // 批量创建流程附属信息
    CreateOrUpdateList: '/api/services/app/AbpFlowLog/CreateOrUpdateList',
    // 分页获取附属信息
    GetPaged: '/api/services/app/AbpFlowLog/GetPaged',
    // 创建流程附属信息
    CreateOrUpdate: '/api/services/app/AbpFlowLog/CreateOrUpdate',
    // 获取流程信息
    GetPaged: '/api/services/app/AbpFlowLog/GetPaged'
  },
  OrganizationUnitOpen: {
    // 根据用户ID获取组织
    GetOrganizationUnitsByUserid: '/api/services/app/OrganizationUnitOpen/GetOrganizationUnitsByUserid'
  },
  Session: {
    GetCurrentUser: '/api/services/app/Session/GetCurrentUser'
  },
  // 快速入口
  AbpReportSysSetting: {
    // 获取AbpReportSysSetting的分页列表信息
    GetPaged: '/api/services/app/AbpReportSysSetting/GetPaged',
    // 添加或者修改AbpReportSysSetting的公共方法
    CreateOrUpdate: '/api/services/app/AbpReportSysSetting/CreateOrUpdate',
    // 获取AbpReportSysSetting的分页列表信息
    GetListByRoleId: '/api/services/app/AbpReportSysSetting/GetListByRoleId',
    // 删除AbpReportSysSetting信息的方法
    Delete: '/api/services/app/AbpReportSysSetting/Delete',
    // 根据当前用户 获取 报表权限
    GetAllReportSysByCurrent: '/api/services/app/AbpReportSysSetting/GetAllReportSysByCurrent',
    // 添加报表权限关联
    UpdateRoleManyReportSys: '/api/services/app/AbpReportSysSetting/UpdateRoleManyReportSys',
    // 根据报表 ID添加权限关联
    UpdateReportSysByRoles: '/api/services/app/AbpReportSysSetting/UpdateReportSysByRoles',
    // 根据快速入口Id获取角色
    GetRoleListByReprotSysId: '/api/services/app/AbpReportSysSetting/GetRoleListByReprotSysId'
  },
  Role: {
    GetAll: '/api/services/app/Role/GetAll'
  },
  AbpArgument: {
    // 生成论证编号
    GetArgumentNo: '/api/services/app/AbpArgument/GetArgumentNo',
    // 分页获取
    GetPaged: '/api/services/app/AbpArgument/GetPaged',
    // 创建论证
    CreateOrUpdate: '/api/services/app/AbpArgument/CreateOrUpdate',
    // 论证扩展（关联项目）
    CreateArgumentExt: '/api/services/app/AbpArgument/CreateArgumentExt',
    // 获取论证关联项目
    GetByProject: '/api/services/app/AbpArgument/GetByProject'
  },
  // 质疑
  ClQuestion: {
    GetPaged: '/api/services/app/ClQuestion/GetPaged',
    CreateOrUpdate: '/api/services/app/ClQuestion/CreateOrUpdate'
  },
  // 投诉
  ClComplain: {
    GetPaged: '/api/services/app/ClComplain/GetPaged',
    CreateOrUpdate: '/api/services/app/ClComplain/CreateOrUpdate'
  },
  UserRoleService: {
    // 根据地区角色获取对应角色人员
    GetUserListByDistrictRoleAsync: '/api/services/app/UserRoleService/GetUserListByDistrictRoleAsync'
  },
  // 委托协议
  CLTrustAgreementInfo: {
    GetPaged: '/api/services/app/CLTrustAgreementInfo/GetPaged',
    CreateOrUpdate: '/api/services/app/CLTrustAgreementInfo/CreateOrUpdate',
    GetOptionList: '/api/services/app/CLTrustAgreementInfo/GetOptionList'
  },
  // 专家费用管理
  ExpertFeeStandard: {
    CreateOrUpdate: '/api/services/app/ExpertFeeStandard/CreateOrUpdate',
    GetPaged: '/api/services/app/ExpertFeeStandard/GetPaged',
    Delete: '/api/services/app/ExpertFeeStandard/Delete'
  },
  // 定时消息
  EnrollNoticeTask: {
    GetPaged: '/api/services/app/EnrollNoticeTask/GetPaged',
    CreateOrUpdate: '/api/services/app/EnrollNoticeTask/CreateOrUpdate'
  },
  // 投标档案存档记录
  CLBidFile: {
    GetPaged: '/api/services/app/CLBidFile/GetPaged',
    CreateOrUpdate: '/api/services/app/CLBidFile/CreateOrUpdate',
    PostPackageNumber: '/api/services/app/CLBidFile/PostPackageNumber',
    CreateRecord: '/api/services/app/CLBidFile/CreateRecord',
    GetRecordPaged: '/api/services/app/CLBidFile/GetRecordPaged'
  },
  CLShiftingFile: {
    CreateOrUpdate: '/api/services/app/CLShiftingFile/CreateOrUpdate',
    GetPaged: '/api/services/app/CLShiftingFile/GetPaged'
  },
  CLBidFileGrantRecord: {
    GetProjectTablePaged: '/api/services/app/CLBidFileGrantRecord/GetProjectTablePaged',
    GetPaged: '/api/services/app/CLBidFileGrantRecord/GetPaged',
    CreateOrUpdate: '/api/services/app/CLBidFileGrantRecord/CreateOrUpdate',
    PostListByProjectId: '/api/services/app/CLBidFileGrantRecord/PostListByProjectId'
  },
  AbpDistrictManagers: {
    GetPaged: '/api/services/app/AbpDistrictManagers/GetPaged',
    CreateOrUpdate: '/api/services/app/AbpDistrictManagers/CreateOrUpdate',
    Delete: '/api/services/app/AbpDistrictManagers/Delete'
  }
}

export default urls
